// Sentry browser init for the Northbridge HVAC portfolio site.
//
// No-ops when VITE_SENTRY_DSN is unset, mirroring the env-flag pattern used
// across the platform.
//
// Sample rates: errors 100%, perf traces 10% in prod / 0% otherwise.
//
// Install:
//   npm install --save @sentry/react
//   npm install --save-dev @sentry/vite-plugin

let initialised = false;

export async function initSentry(): Promise<void> {
  if (initialised) return;
  if (typeof window === 'undefined') return;

  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  initialised = true;

  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore -- @sentry/react is an optional runtime dependency
    const Sentry = await import(/* @vite-ignore */ '@sentry/react');
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      sampleRate: 1.0,
      tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 0,
    });
  } catch {
    initialised = false;
  }
}
